import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Heading/Heading';

class Heading extends React.Component{

  render(){
    let section = this.props.section;
    return (
      <section className="heading" style={{paddingBottom: 20}}>
        <div className="heading-section intro-text" style={{padding: '0px'}}>
          <InlineEditableElement el='h1' fontFamilyChanged={this.props.fontFamilyChanged} {...this.props.inlineEditorProps} style={{marginBottom: 0}} className="intro-heading" html={section.prop('title')} onChange={this.props.titleChanged.bind(this)} inlineEditingEnabled={this.props.inlineEditingEnabled}/>
          {typeof section.prop('subtitle') !== 'undefined' || this.props.inlineEditingEnabled ? <InlineEditableElement
            fontFamilyChanged={this.props.fontFamilyChanged} className="intro-subheading" html={section.prop('subtitle')} {...this.props.inlineEditorProps} onChange={this.props.subtitleChanged.bind(this)} inlineEditingEnabled={this.props.inlineEditingEnabled} /> : null}
        </div>
      </section>
    );
  }

}

export default hoc(Heading);
